module.exports = __webpack_public_path__ + "static/img/pic_szh_cgal_gk_bg.3bcb732f.jpg";